// src/components/ui/ContentTypeIcon.jsx
import React from 'react';
import { Box, Tooltip, useTheme, alpha } from '@mui/material';
import {
  Image as PostIcon,
  Collections as CarouselIcon,
  Videocam as VideoIcon,
  MovieCreation as ReelIcon,
  Article as ArticleIcon,
  Celebration as EventIcon,
  NotificationsActive as AnnouncementIcon,
  LocalOffer as PromotionIcon,
  Poll as PollIcon,
  EmojiEvents as ContestIcon
} from '@mui/icons-material';

/**
 * Component to display content type icon with appropriate color
 */
const ContentTypeIcon = ({ type, showTooltip = true, size = 'small', ...props }) => {
  const theme = useTheme();
  
  // Define configuration for different content types
  const typeConfig = {
    post: {
      icon: <PostIcon fontSize={size} />,
      label: 'Post',
      color: theme.palette.primary.main
    },
    story: {
      icon: <PostIcon fontSize={size} />,
      label: 'Story',
      color: theme.palette.secondary.main
    },
    reel: {
      icon: <ReelIcon fontSize={size} />,
      label: 'Reel',
      color: theme.palette.error.main
    },
    video: {
      icon: <VideoIcon fontSize={size} />,
      label: 'Video',
      color: theme.palette.error.main
    },
    carousel: {
      icon: <CarouselIcon fontSize={size} />,
      label: 'Carousel',
      color: theme.palette.info.main
    },
    article: {
      icon: <ArticleIcon fontSize={size} />,
      label: 'Article',
      color: theme.palette.info.main
    },
    announcement: {
      icon: <AnnouncementIcon fontSize={size} />,
      label: 'Announcement',
      color: theme.palette.warning.main
    },
    promotion: {
      icon: <PromotionIcon fontSize={size} />,
      label: 'Promotion',
      color: theme.palette.success.main
    },
    event: {
      icon: <EventIcon fontSize={size} />,
      label: 'Event',
      color: theme.palette.secondary.main
    },
    poll: {
      icon: <PollIcon fontSize={size} />,
      label: 'Poll',
      color: theme.palette.info.main
    },
    contest: {
      icon: <ContestIcon fontSize={size} />,
      label: 'Contest',
      color: theme.palette.warning.main
    }
  };
  
  // Get config or use default
  const config = typeConfig[type] || {
    icon: <PostIcon fontSize={size} />,
    label: type?.charAt(0)?.toUpperCase() + type?.slice(1),
    color: theme.palette.grey[500]
  };
  
  const iconElement = (
    <Box
      sx={{
        display: 'inline-flex',
        color: config.color,
        ...props.sx
      }}
      {...props}
    >
      {config.icon}
    </Box>
  );
  
  return showTooltip ? (
    <Tooltip title={config.label}>
      {iconElement}
    </Tooltip>
  ) : iconElement;
};

export default ContentTypeIcon;